var apiURL = "https://tools.ubivox.com/api/resolve";

export default apiURL;



// WEBPACK FOOTER //
// ./src/api.js